import React from 'react';
import PropTypes from 'prop-types';
import {ButtonLink} from '@homeaway/react-buttons';

function ClearButton({className, disabled, handleClick, handleKeyDown, label}) {
    return (
        <ButtonLink
            type="button"
            className={className}
            disabled={disabled}
            aria-hidden={disabled ? 'true' : 'false'}
            onClick={handleClick}
            onKeyDown={handleKeyDown}
            label={label}
        />
    );
}

ClearButton.defaultProps = {
    className: 'picker__clear',
    disabled: true,
    handleClick: () => {},
    handleKeyDown: () => {},
    label: 'Clear',
};

ClearButton.propTypes = {
    /** Classes that will be applied on the clear button */
    className: PropTypes.string,
    /** Flag to disable or enable the clear button */
    disabled: PropTypes.bool,
    /** Function to call when clear button clicked */
    handleClick: PropTypes.func,
    /** Function to call when key pressed to select clear button */
    handleKeyDown: PropTypes.func,
    /** The text label displayed on the clear button */
    label: PropTypes.string,
};

export default ClearButton;
